export default __webpack_public_path__ + "static/pry-logo-7d2db0830d8817f48e2b6c3bf8957707.png";